import React, { useEffect, useState } from 'react'
import { Loader2Icon } from 'lucide-react'

import { useAppSelector } from '../../../../store/hooks'
import { selectedEvent } from '../../../../store/events/eventsSlice'
import { getFloatPrice } from '../../../../helpers/price'
import { getCurrency, getTotalPrices } from '../../../../helpers/payment'
import useToasterHelper from '../../../../helpers/ToasterHelper'

import RegistrationDyDayService from '../../../../services/firebase-service/registration-by-day/RegistrationDyDayService'
import RegistrationFeesService from '../../../../services/firebase-service/registration-fees/RegistrationFeesService'
import RegistrationTicketService from '../../../../services/firebase-service/registration-tickets/RegistrationTicketService'

type IProps = {
  revenueType: string
  imgUrl?: string
}
const MONY_BAG_URL = '/assets/img/MoneyBag.png'

const ManageEventRevenueHeader = (props: IProps) => {
  const toast = useToasterHelper()

  const currentEvent = useAppSelector(selectedEvent)
  const [notPaidAmount, setNotPaidAmount] = useState<number>(0)
  const [paidAmount, setPaidAmount] = useState<number>(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getData = async () => {
      try {
        setLoading(true)
        const eventId = currentEvent.Event?.id
        if (eventId) {
          const registrationsByDay = await RegistrationDyDayService.getByEventIds([eventId])
          const registrationsFees = await RegistrationFeesService.getByEventId(eventId)
          const registrationsTickets = await RegistrationTicketService.getByEventId(eventId)

          const { unpaidTotal, paidTotal } = getTotalPrices({
            registrationsEntries: registrationsByDay,
            registrationsFees: registrationsFees,
            registrationsTickets: registrationsTickets,
            isChargeSalesTax: currentEvent?.EventPaymentSettings?.chargeSalesTax ?? false,
          })

          setNotPaidAmount(unpaidTotal / 100)
          setPaidAmount(paidTotal / 100)
        }
      } catch (error) {
        console.error('error: ', error)
        toast.error({
          message: 'Something went wrong while revenue',
        })
      } finally {
        setLoading(false)
      }
    }
    getData().then()
  }, [currentEvent, toast])

  const currency = getCurrency(currentEvent?.Event?.currency)

  return (
    <>
      <div className="flex flex-col md:flex-row mb-3 md:mb-0 md:items-center w-full">
        <div className="bg-[#00B6AA26] rounded-md p-1 w-12 h-12 mr-4">
          <img
            className="w-full"
            src={`${props.imgUrl || '/assets/cp_icons/Two Tickets-3.svg'}`}
            alt="groupIcon"
          />
        </div>
        <div className="text-SeabiscuitDark200ThemeColor font-semibold">
          <span className="capitalize text-lg">{props.revenueType} revenue</span>
        </div>
      </div>

      <div className="flex flex-col mt-6 text-nr text-SeabiscuitDark200ThemeColor">
        <div className="flex items-center mb-2">
          <div className={'mr-2'}>
            <img src={MONY_BAG_URL} alt="Mony bag" />
          </div>
          <span className="w-40 mr-2">Sales to date:</span>
          {loading ? (
            <Loader2Icon className="animate-spin w-4" />
          ) : (
            <span>{getFloatPrice(`${currency}${paidAmount}`)}</span>
          )}
        </div>
        <div className="flex items-center mb-2">
          <div className={'mr-2'}>
            <img src={MONY_BAG_URL} alt="Mony bag" />
          </div>
          <span className="w-40 mr-2">Outstanding sales:</span>
          {loading ? (
            <Loader2Icon className="animate-spin w-4" />
          ) : (
            <span>{getFloatPrice(`${currency}${notPaidAmount > 0 ? notPaidAmount : 0}`)}</span>
          )}
        </div>
      </div>

      <div className="w-full h-[1px] bg-[#D3DAEE] my-4"></div>
    </>
  )
}

export default ManageEventRevenueHeader
